import { __ } from "@wordpress/i18n";
import { useState } from "react";
import SbUtils from "../../Utils/SbUtils";
import Button from "../Common/Button";
import ToggleSet from "../Common/ToggleSet";

/**
 * PopupEmbedModal Component
 *
 * Modal for embedding review alerts via shortcode or adding to pages.
 */
const PopupEmbedModal = ( { popupId, popupName, editorNotification, sbCustomizer, onClose } ) => {
    const [ activeView, setActiveView ] = useState( 'copy' );
    const [ choosedPageID, setChoosedPageID ] = useState( null );

    const pagesListToggle = sbCustomizer?.wordpressPageLists?.map( page => ( {
        value: page.id,
        label: page.title.slice( 0, 100 )
    } ) ) || [];

    const views = {
        copy: {
            heading: __( 'Embed Review Alert', 'sb-customizer' )
        },
        addPage: {
            heading: __( 'Add to Page', 'sb-customizer' ),
            backButton: true
        }
    };

    const shortcode = `[sbr-popup id=${popupId}]`;

    return (
        <div className='sb-embedfeed-modal sb-fs'>
            <div className='sb-embedfeed-modal-heading sb-fs'>
                { views[ activeView ].backButton && (
                    <span
                        className='sb-embedfeed-modal-back sb-dark-text sb-text-tiny sb-bold'
                        onClick={ () => setActiveView( 'copy' ) }
                    >
                        { SbUtils.printIcon( 'chevron-left' ) }
                        { __( 'Embed Review Alert', 'sb-customizer' ) }
                    </span>
                ) }
                <h4 className='sb-h4'>{ views[ activeView ].heading }</h4>
            </div>

            <div className='sb-embedfeed-modal-content sb-fs'>
                { activeView === 'copy' && (
                    <>
                        <div className='sb-fs'>
                            <strong className="sb-fs">
                                { __( 'The review alert will automatically display on the pages you\'ve configured in the Location settings.', 'sb-customizer' ) }
                            </strong>
                        </div>

                        <div className='sb-fs' style={ { marginTop: '20px' } }>
                            <strong className="sb-fs">
                                { __( 'Or add the shortcode to manually control placement:', 'sb-customizer' ) }
                            </strong>
                            <div className='sb-embedfeed-modal-info sb-fs'>
                                <span className='sb-text sb-fs'>{ shortcode }</span>
                                <Button
                                    size='large'
                                    type='primary'
                                    text={ __( 'Copy', 'sb-customizer' ) }
                                    icon='copy'
                                    onClick={ () => {
                                        SbUtils.copyToClipBoard( shortcode, editorNotification );
                                    } }
                                />
                            </div>
                        </div>

                        <div className='sb-fs' style={ { marginTop: '20px' } }>
                            <strong className="sb-fs">
                                { __( 'Or use the built in WordPress block or widget', 'sb-customizer' ) }
                            </strong>
                            <div className='sb-embedfeed-modal-addbtns sb-fs'>
                                <Button
                                    fullwidth='true'
                                    size='large'
                                    type='secondary'
                                    boxshadow='false'
                                    text={ __( 'Add to a Page', 'sb-customizer' ) }
                                    icon='addpage'
                                    onClick={ () => setActiveView( 'addPage' ) }
                                />
                                { sbCustomizer?.themeSupportsWidgets && (
                                    <Button
                                        fullwidth='true'
                                        size='large'
                                        type='secondary'
                                        boxshadow='false'
                                        text={ __( 'Add to a Widget', 'sb-customizer' ) }
                                        icon='addwidget'
                                        onClick={ () => {
                                            window.open( sbCustomizer.widgetsPageURL, '_blank' );
                                        } }
                                    />
                                ) }
                            </div>
                        </div>
                    </>
                ) }

                { activeView === 'addPage' && (
                    <>
                        <div className='sb-fs'>
                            <strong className='sb-embedfeed-modal-pages-head sb-dark2-text sb-fs'>
                                { __( 'Select Page', 'sb-customizer' ) }
                            </strong>
                            <div className='sb-embedfeed-modal-pageslist sb-fs'>
                                { pagesListToggle.length > 0 && (
                                    <ToggleSet
                                        customClass='sb-togglset-control'
                                        options={ pagesListToggle }
                                        value={ choosedPageID }
                                        onClick={ ( pageID ) => setChoosedPageID( pageID ) }
                                    />
                                ) }
                            </div>
                        </div>
                        <div className='sb-embedfeed-modal-actbtns'>
                            <Button
                                size='medium'
                                type='secondary'
                                text={ __( 'Cancel', 'sb-customizer' ) }
                                onClick={ () => setActiveView( 'copy' ) }
                            />
                            <Button
                                size='medium'
                                type='primary'
                                text={ __( 'Add', 'sb-customizer' ) }
                                icon='success'
                                onClick={ () => {
                                    if ( choosedPageID !== null ) {
                                        const wizardUrl = `${sbCustomizer.adminPostURL}?post=${choosedPageID}&action=edit&sbr_popup_wizard=1&popup_id=${popupId}`;
                                        window.open( wizardUrl, '_blank' );
                                    }
                                } }
                            />
                        </div>
                    </>
                ) }
            </div>
        </div>
    );
};

export default PopupEmbedModal;
